import iconTrash from "../../assets/icon-trash.svg";
import iconArrowRight from "../../assets/icon-arrow-right.svg";

interface ButtonBlockProps {
  label: string;
  link: string;
  onEdit: () => void;
  onDelete: () => void;
}

export function ButtonBlock({ label, link: _link, onEdit, onDelete }: ButtonBlockProps) {
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onEdit}
        className="h-[51px] px-4 rounded-2xl bg-btn-action text-text-btn text-base font-semibold flex items-center gap-6"
      >
        {label || "Button"}
        <img src={iconArrowRight} alt="" width={24} height={24} />
      </button>
      <button type="button" onClick={onDelete} className="p-1 shrink-0 hover:opacity-70">
        <img src={iconTrash} alt="Delete button" width={20} height={20} />
      </button>
    </div>
  );
}
